export interface ProjectData {
  name: string;
  pages: number;
  download_link: string;
}

export const Projects: ProjectData[] = [
  {
    name: "resume",
    pages: 2,
    download_link: "Steven Grullon - Resume (Compressed)",
  },
  {
    name: "spitzer-portfolio",
    pages: 34,
    download_link: "Steven Grullon - Spitzer Portfolio (Compressed)",
  },
  {
    name: "spitzer-work-sample",
    pages: 17,
    download_link: "Steven Grullon - Spitzer Work Sample (Compressed)",
  },
  {
    name: "sca-work-sample",
    pages: 16,
    download_link: "Steven Grullon - SCA Work Sample (Compressed)",
  },
  {
    name: "precision-stone-work-sample",
    pages: 17,
    download_link: "Steven Grullon - Precision Stone Work Sample (Compressed)",
  },
  {
    name: "art-portfolio-black",
    pages: 21,
    download_link: "Steven Grullon - Art Portfolio (Compressed)",
  },
  {
    name: "photography-portfolio-black-and-white",
    pages: 22,
    download_link: "Steven Grullon - Photography Portfolio - B&W Film (Compressed)",
  },
  {
    name: "photography-portfolio-color-film",
    pages: 20,
    download_link: "Steven Grullon - Photography Portfolio - Color Film (Compressed)",
  },
  {
    name: "photography-portfolio-digital",
    pages: 42,
    download_link: "Steven Grullon - Photography Portfolio - Digital (Compressed)",
  },
];
